module.exports = __webpack_public_path__ + "img/6.40f5c7e4.jpg";